// src/pages/Layer7Attacks.js
import React from 'react';
import Layout from '../components/Layout';

function Layer7Attacks() {
    return (
        <Layout>
            <div className="p-8">
            <h1 className="text-4xl font-bold text-white mb-8">Layer 7 Attacks</h1>
            <div className="mb-16 gap-16">
                   <h1 className="text-4xl font-bold text-gray-400 mb-8">Coming Soon</h1>
                </div>
            </div>
        </Layout>
    );
}

export default Layer7Attacks;